import { render, staticRenderFns } from "./vegetableDialog.vue?vue&type=template&id=eed2b2de&scoped=true&"
import script from "./vegetableDialog.vue?vue&type=script&lang=js&"
export * from "./vegetableDialog.vue?vue&type=script&lang=js&"
import style0 from "./vegetableDialog.vue?vue&type=style&index=0&id=eed2b2de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed2b2de",
  null
  
)

export default component.exports